module.exports = __webpack_public_path__ + "img/regulations.badec27.svg";